import React from 'react'
import PropTypes from 'prop-types'

import emailIcon from '../assets/email.svg'
import './SignUp.scss'

const SignUp = ({ bg, title, text, buttonText }) => {
  return (
    <div className='swiper-slide fi_signup'>
      <div id='fi_signup__bg' className='fi_scene__bg' style={{ backgroundImage: `url(${bg})` }} />

      <div className='fi_signup__content'>
        <h2 id='fi_signup__heading' className='fi_signup__heading'><span className='fi_signup__heading--text'>{ title }</span></h2>
        <p id='fi_signup__text' className='fi_signup__text'><span className='fi_signup__text--text'>{ text }</span></p>
        <div className='fi_signup__input'>
          <img className='fi_signup__input-icon' src={emailIcon} alt='email' />
          <input className='fi_signup__input-field' type='email' placeholder='Enter your email here' />
        </div>
        <div id='fi_signup__button' className='fi_signup__button'>{buttonText.toUpperCase()}</div>
        <div className='fi_signup__terms'>
          By clicking "Sign Up" I agree to the <strong>Privacy Policy</strong> and our <strong>Terms of Service</strong>
        </div>
      </div>
    </div>
  )
}

SignUp.propTypes = {
  bg: PropTypes.string,
  title: PropTypes.string,
  text: PropTypes.string,
  buttonText: PropTypes.string,
}

export default SignUp



// WEBPACK FOOTER //
// ./src/templates/fashionIcon/components/SignUp.js